import { useState, useEffect, useRef } from "react";
import "./style.css";

const ContextMenu = ({ contextData, position, actions, onClose }) => {
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [onClose]);

  if (!contextData || !position) return null;

  const returnQuadrantTitlte = (identifier) => {
    if (identifier === "ur") {
      return "Upper Right (UR)";
    }
  };
  const renderQuadrantDetails = () => {
    return (
      <div className="context_quadrant_container">
        <p>QUADRANT</p>
        <p>{returnQuadrantTitlte(contextData?.identifier)}</p>
        <p>
          condition :
          {contextData?.conditions?.map((el) => el.condition_identifier)}
        </p>
      </div>
    );
  };
  const renderToothDetails = () => {
    return (
      <div className="context_quadrant_container">
        <p>Tooth</p>
        <p>Type : {contextData?.condition_type}</p>
        <p>Condition : {contextData?.condition_identifier}</p>
        <p>
          Surfaces:{" "}
          {contextData?.conditions
            ?.flatMap((el) => el.surfaces) // Flatten all surfaces
            .join(", ")}{" "}
          {/* Join surfaces into a readable string */}
        </p>
      </div>
    );
  };

  return (
    <div
      ref={menuRef}
      className="context-menu"
      style={{ top: position.y, left: position.x }}
    >
      {contextData?.type === "quadrant"
        ? renderQuadrantDetails()
        : renderToothDetails()}
    </div>
  );
};

export default ContextMenu;

// <>
//   <p>
//     <strong>Type:</strong> {contextData.type}
//   </p>
//   <p>
//     <strong>ID:</strong>{" "}
//     {contextData.identifier || contextData.tooth_id}
//   </p>
//   <p>
//     <strong>Observation:</strong> {contextData.observation || "N/A"}
//   </p>

//   {/* Render actions */}
//   {actions.map(({ label, onClick }, index) => (
//     <button key={index} onClick={() => onClick(contextData)}>
//       {label}
//     </button>
//   ))}
// </>
